import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root',
})
export class GoogleMapsLoaderService {
    private _loaded = false;

    load(): void {
        if (this._loaded || typeof window === 'undefined') {
            return;
        }
        this._loaded = true;

        const key = environment.googleMapsApiKey;

        (((g) => {
            // eslint-disable-next-line prefer-const
            let h: Promise<void> | undefined,
                a: HTMLScriptElement,
                k: string;
            const p = 'The Google Maps JavaScript API',
                c = 'google',
                l = 'importLibrary',
                q = '__ib__',
                m = document,
                b: any = window;

            const bMaps = (b[c] = b[c] || {});
            const d = (bMaps.maps = bMaps.maps || {});
            const r = new Set<string>();
            const e = new URLSearchParams();
            const u = () =>
                h ||
                (h = new Promise(async (f, n) => {
                    a = m.createElement('script');
                    e.set(
                        'libraries',
                        [...r, 'places', 'marker'].join(',')
                    );
                    for (k in g) {
                        e.set(
                            k.replace(/[A-Z]/g, (t) => '_' + t[0].toLowerCase()),
                            (g as any)[k]
                        );
                    }
                    e.set('callback', c + '.maps.' + q);
                    a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
                    d[q] = f;
                    a.onerror = () =>
                        (h = Promise.reject(
                            new Error(p + ' could not load.')
                        ) as any);
                    a.nonce =
                        m.querySelector<HTMLScriptElement>('script[nonce]')
                            ?.nonce || '';
                    m.head.append(a);
                }));

            d[l]
                ? console.warn(p + ' only loads once. Ignoring:', g)
                : (d[l] = (f: string, ...n: any[]) =>
                      r.add(f) && u().then(() => d[l](f, ...n)));
        }) as (g: Record<string, string>) => void)({
            v: 'beta',
            key,
        });
    }
}
